module.exports = __webpack_public_path__ + "images/emails/signatures/jeremy-f7e72452bc8892ceefb8c9b626716129.jpg";